import OpenWpsBridge from './OpenWpsBridge';
import { AbilityConstants } from '../constants/AbilityConstants';
import DeviceEnvUtil from '../../utils/DeviceEnvUtil';
import { Platfrom } from '../../utils/PlatformConstants';
import PageParamsUtil from '../../utils/PageParamsUtil';
import TemplateRequest from '../data/TemplateRequest';
import { ShareObject, ShareContent } from './ShareObject';
import i18n from '@/i18n';

function isSupportFunctionOnCurrentPlatform() {
  const plaform: Platfrom = DeviceEnvUtil.getPlatform();
  let supportPlatform: Array<Platfrom> = [];
  const functionList = AbilityConstants;
  const module = OpenWpsBridge.getModuleTag();
  for (const index in functionList) {
    const routerOb = functionList[index];
    if (module === routerOb.key) {
      supportPlatform = routerOb.platform;
    }
  }
  return supportPlatform.includes(plaform);
}

function getFunctionDefaultViewKey() {
  const functionList = AbilityConstants;
  const module = OpenWpsBridge.getModuleTag();
  let defaultViewKey = '';
  for (const index in functionList) {
    const routerOb = functionList[index];
    if (module === routerOb.key) {
      defaultViewKey = routerOb.viewKey as string;
    }
  }
  if (defaultViewKey === undefined || defaultViewKey === '') {
    defaultViewKey = TemplateRequest.getDefaultViewKey();
  }
  return defaultViewKey;
}

function getFunctionBtnTips() {
  const plaform = DeviceEnvUtil.getPlatform();
  let supportPlatform: Array<Platfrom> = [];
  const functionList = AbilityConstants;
  const module = OpenWpsBridge.getModuleTag();
  for (const index in functionList) {
    const routerOb = functionList[index];
    if (module === routerOb.key) {
      supportPlatform = routerOb.platform;
    }
  }
  if (supportPlatform.length == 0) {
    return i18n.global.t('ability.buttonTip.developing');
  }
  if (supportPlatform.includes(plaform)) {
    return i18n.global.t('ability.buttonTip.opening');
  } else {
    if (supportPlatform.includes(Platfrom.ANDROID) && supportPlatform.includes(Platfrom.IOS)) {
      return i18n.global.t('ability.buttonTip.mobileOnly');
    } else if (supportPlatform.includes(Platfrom.ANDROID)) {
      return i18n.global.t('ability.buttonTip.androidOnly');
    } else if (supportPlatform.includes(Platfrom.IOS)) {
      return i18n.global.t('ability.buttonTip.iosOnly');
    } else {
      return i18n.global.t('ability.buttonTip.developing');
    }
  }
}

function getAbilityName() {
  const params = PageParamsUtil.getPageQueryParams();
  return decodeURIComponent(params['ability']);
}

function getAbilityBusinessId() {
  const params = PageParamsUtil.getPageQueryParams();
  return params['_business_id'] || 'empty';
}

function getViewKey(): string {
  const params = PageParamsUtil.getPageQueryParams();
  let viewKey = TemplateRequest.getDefaultViewKey();
  let hasCustomViewKey = false;
  if (params['view_key'] !== undefined && params['view_key'] !== '') {
    hasCustomViewKey = true;
    viewKey = params['view_key'];
  } else if (params['share_json'] === undefined || params['share_json'] === '') {
    hasCustomViewKey = false;
  } else {
    const shareObject: ShareObject = getShareObj();
    if (shareObject === null || shareObject.view_key === null || shareObject.view_key === '') {
      hasCustomViewKey = false;
    } else {
      hasCustomViewKey = true;
      viewKey = shareObject.view_key;
    }
  }
  if (hasCustomViewKey) {
    return viewKey;
  } else {
    return getFunctionDefaultViewKey();
  }
}

function getShareObj(): ShareObject {
  const params = PageParamsUtil.getPageQueryParams();
  const shareJsonStr: string = decodeURIComponent(params['share_json']);
  console.log('share-json: ', shareJsonStr);
  try {
    const shareObj = JSON.parse(shareJsonStr);
    console.log('share-obj: ', shareObj);
    const shareContentObj = shareObj['share_content'];
    const shareContent = new ShareContent(
      shareContentObj['title'],
      shareContentObj['desc'],
      shareContentObj['icon'],
    );
    return new ShareObject(shareObj['view_key'], shareObj['wx_key'], shareContent);
  } catch (error) {
    return new ShareObject('', '', new ShareContent('', '', ''));
  }
}

function getDownloadUrl(): string {
  return 'https://wpsgo.com/' + getDownloadChan();
}

function getDownloadChan(): string {
  const params = PageParamsUtil.getPageQueryParams();
  let chan = decodeURIComponent(params['chan']);
  if (chan === undefined || chan === 'undefined' || chan === '') {
    chan = 'rlS0BsJKP';
  }
  return chan;
}

function isAutoJumpDownload(): boolean {
  const params = PageParamsUtil.getPageQueryParams();
  const chan = decodeURIComponent(params['autoJump']);
  if (chan === undefined || chan === 'undefined' || chan === '') {
    // 默认自动跳转
    return true;
  }
  return chan === '1';
}

function isUseWxOpenTag(): boolean {
  const params = PageParamsUtil.getPageQueryParams();
  const iChan = decodeURIComponent(params['iUseWxOpenTag']);
  // ios若有配置则单独判断
  if (iChan !== undefined && iChan !== 'undefined' && iChan !== '' && DeviceEnvUtil.isIOS()) {
    return iChan === '1';
  }
  const aChan = decodeURIComponent(params['useWxOpenTag']);
  if (aChan === undefined || aChan === 'undefined' || aChan === '') {
    // 默认自动使用微信开放标签
    return true;
  }
  return aChan === '1';
}

function isAutowWakeup(): boolean {
  // 外链指定了商店地址时，只做落地页 → 商店，不再 scheme 唤起
  if (getExternalStoreUrl()) {
    return false;
  }
  const params = PageParamsUtil.getPageQueryParams();
  const chan = decodeURIComponent(params['autoWakeup']);
  if (chan === undefined || chan === 'undefined' || chan === '') {
    // 默认进入页面尝试自动唤起
    return true;
  }
  return chan === '1';
}

/** 外链传入的 App Store / 应用商店地址，如 storeUrl=encodeURIComponent(https://apps.apple.com/...) */
function getExternalStoreUrl(): string {
  return new URLSearchParams(window.location.search).get('storeUrl') || '';
}

export default {
  isSupportFunctionOnCurrentPlatform,
  getFunctionBtnTips,
  getAbilityName,
  getAbilityBusinessId,
  getShareObj,
  getViewKey,
  getDownloadUrl,
  getDownloadChan,
  isAutoJumpDownload,
  isAutowWakeup,
  isUseWxOpenTag,
  getExternalStoreUrl,
};
